<template>
  <div class="dlrVRBottomMenu-pop">
    <div class="dlrVRBottomMenu-pop-bg">
      <a
        href="javascript:void(0);"
        class="dlrVRBottomMenu-pop-close"
        @click="hide"
      ></a>
      <div class="dlrVRBottomMenu-pop-box">
        <div class="dlrVRBottomMenu-pop-title">
          <p>填写电话备忘</p>
        </div>
        <div class="notes-pop-tips">
          <p>提交后，备忘信息自动为您展示在带看任务中</p>
        </div>
        <div class="notes-pop-form">
          <div class="notes-pop-form-bg">
            <div class="notes-pop-form-item">
              <label class="notes-pop-form-label">客户姓名</label>
              <div class="notes-pop-form-card">
                <input
                  v-model="fromValue.customerName"
                  type="text"
                  maxlength="13"
                  placeholder="请输入客户姓名"
                />
              </div>
              <div class="notes-pop-form-other">
                <a
                  class="notes-pop-form-fork"
                  href="javascript:void(0);"
                  @click="resetFiles('customerName')"
                ></a>
              </div>
            </div>
            <div class="notes-pop-form-item">
              <label class="notes-pop-form-label">手机号码<em>*</em></label>
              <div class="notes-pop-form-card">
                <input
                  v-model="fromValue.phone"
                  type="tel"
                  ref="tel"
                  placeholder="请输入客户手机号"
                />
              </div>
              <div class="notes-pop-form-other">
                <a
                  class="notes-pop-form-fork"
                  href="javascript:void(0);"
                  @click="resetFiles('phone')"
                ></a>
              </div>
            </div>
          </div>
          <div class="notes-pop-form-btn">
            <a
              v-stat:click="{
                action: 'dlr_b_vr_beiwanglu_tijiao_click',
                extend: { channelId },
              }"
              href="javascript:void(0);"
              @click="save" >
              <h3>保存电话</h3>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="dlrVRBottomMenu-pop-mask"></div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import icsApi from '@/apis/ics.api';
import layerManager from '@/services/layer.manager';
/**
 * 手机号码判断 11位格式
 * */
export const RegexpPhone = /^1[3|4|5|6|7|8|9]\d{9}$/;
export function validPhoneFormat(telNumer) {
  return RegexpPhone.test(telNumer);
}
export default {
  name: '',
  props: {
    form: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      callStatus: 'callStatus/callStatus',
      vrSalesInfo: 'sales/vrSalesInfo',
    }),
    channelId () {
      return this.vrSalesInfo.channelId;
    },
    saleId () {
      return this.vrSalesInfo.salesId;
    },
    fromValue: {
      get () {
        return this.form;
      },
      set (val) {
        this.form = val;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.tel.focus();
    })
  },
  methods: {
    hide () {
      this.$emit('hide');
    },
    resetFiles(file) {
      file === 'phone'
        ? (this.fromValue.phone = '')
        : (this.fromValue.customerName = '');
    },
    save () {
      if (!validPhoneFormat(this.fromValue.phone)) {
        layerManager.toast({ propsData: { message: '请输入正确的手机号码' } }, 2000);
        return;
      }
      icsApi
        .remark({
          ...this.fromValue,
          channelId: this.channelId,
          saleId: this.saleId,
        })
        .then((res) => {
          if (res.returncode === 0 ) {
            layerManager.toast({ propsData: { message: '保存成功' } }, 2000);
            setTimeout(() => {
              this.hide();
            }, 500);
          }
        });
    },
  },
};
</script>
